<template>
  <div>
  <div class="overlay"></div>
    <div class="modal_fixed">
            <div class="new_achievement_box modal_cont" id="new_achievement_modal">
              <img class="btn_close" @click="$emit('close')" src="static/images/store/icon-close-back-popup.svg">
              <h1>{{ getTranslations.home_modals_achievements_title }} {{ achievementInfo.achievementLevelName }}</h1>
              <p>{{ getTranslations.home_modals_achievements_new_congratulations }}<br> {{ getTranslations.home_modals_achievements_new_answered }} {{ achievementInfo.threshold }} {{ getTranslations.home_modals_achievements_new_questions }} "{{ achievementInfo.achievementLevelName }}"!</p>
              <img :src="achievementInfo.image" class="icon_achievement">
              <h2>{{ getTranslations.home_modals_achievements_new_reward }}</h2>
              <achievement-reward :achievement-info="achievementInfo" @read="(value) => $emit('read', value)"/>

              <p class="achievement_share_fb" v-if="facebookFunctionality">
                {{ getTranslations.home_fb_share_achievements_bonus }}
              </p>
              <button type="" class="invite_friends_btn" v-if="facebookFunctionality" @click.prevent="shareToFb()">
                <img src="static/images/home/logo-facebook.svg">
                <p>{{ getTranslations.home_fb_share_achievements_share }}</p>
              </button>
            </div>
          </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import FacebookMixin from '@/common/mixins/facebookIntegration';
import AchievementReward from '@/components/home/modals/achievements/AchievementReward';
import modals from '../../../../common/modals';

export default {
  name: 'new-achievement',
  components: { AchievementReward },
  mixins: [FacebookMixin],
  props: {
    achievementInfo: Object,
  },
  data() {
    return {
      action: 'ACHIEVEMENT',
      redirectUrl: '',
      fb_error: false,
    };
  },
  created() {
    this.redirectUrl = `${window.location.href}/${this.achievementInfo.achievementLevelName}/${this.getLocale || localStorage.getItem('locale')}/`;
    if (this.facebookFunctionality) {
      this.forceFbToScrapNewMetadata(this.redirectUrl, () => {
        // eslint-disable-next-line
        console.log('successful scrapping!');
      });
    }
  },
  methods: {
    close() {
      modals.showHideModal(this);
    },
    showError() {
      this.fb_error = true;
    },
    shareToFb() {
      this.fb_error = false;
      this.points = this.getFbPoints;
      this.share(
        this.userDetails.facebookId,
        this.userDetails.id,
        // eslint-disable-next-line
        () => { console.log('successful achievement share!'); },
        this.showError,
      );
    },
  },
  computed: {
    ...mapState('common', [
      'facebookFunctionality',
      'userDetails',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/achievements/NewAchievement.vue